import bidapi from 'api/bidapi'
import getPagination from '../../../utilities/functions/getPagination'
import { getQueryString } from '@components/AuctionDetails/useFilter'
import { getCookie } from 'cookies-next'
import AuctionDetails from '@components/AuctionDetails'
import getServerSideAccessToken from '@utilities/auth/server/getServerSideAccessToken'

export async function getServerSideProps(context: any) {
  const { auctionId, pageId } = context.params
  const queryString = getQueryString(context.query)

  let apiError = false

  const token = await getServerSideAccessToken(context)

  const itemListingPageApi = await bidapi({
    url: `${process.env.NEXT_PUBLIC_AUCTION_API}/item/itemListingPage/${auctionId}`,
    token,
    context,
  }).catch(() => (apiError = true))

  const initialItemsApi = bidapi({
    url: `${process.env.NEXT_PUBLIC_AUCTION_API}/item/getItemsByAuctionId/${auctionId}?${queryString}`,
    token,
    context,
  }).catch(() => (apiError = true))
  const totalItemsApi = bidapi({
    url: `${process.env.NEXT_PUBLIC_AUCTION_API}/item/getItemsCountByAuctionId/${auctionId}?${queryString}`,
    token,
    context,
  }).catch(() => (apiError = true))

  const [
    initialItems,
    totalItems,
    { marketingTile, allOffers, auction, conditions },
  ] = await Promise.all([initialItemsApi, totalItemsApi, itemListingPageApi])

  if (apiError) {
    // any unclassified api error considered redirect level upper
    // could be altered if api returns the error reason
    return {
      redirect: {
        destination: '/category/all/1',
        permanent: false,
      },
    }
  }

  const initialPagination = getPagination(totalItems, pageId)

  const initListView =
    getCookie('isListView', {
      req: context.req,
      res: context.res,
      path: '/',
    }) || false

  return {
    props: {
      auction,
      allOffers: allOffers || null,
      marketingTile,
      initialItems,
      initialPagination,
      conditions,
      initListView,
    },
  }
}

const Details = (props: any) => {
  return <AuctionDetails {...props} />
}

export default Details
